import { useCallback } from 'react';
import { useOpenCreateGoalDialog } from 'shared/contexts/goal-form/use-open-create-goal-dialog';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { Goal } from 'shared/types/goal';

import { useCreateSubGoalAllowed } from './use-create-sub-goal-allowed';

export const useAddSubGoal = (goal?: Goal) => {
  const openCreateGoalDialog = useOpenCreateGoalDialog();
  const openPremiumDialog = useOpenPremiumDialog();
  const { allowed } = useCreateSubGoalAllowed();

  const onAddSubGoal = useCallback(() => {
    if (!goal) {
      return;
    }
    if (!allowed) {
      openPremiumDialog();
      return;
    }

    openCreateGoalDialog({ parentIds: [goal.id] });
  }, [goal, allowed, openCreateGoalDialog, openPremiumDialog]);

  return { onAddSubGoal };
};
